import Navbar from '../../components/layout/Navbar';
import InventoryContent from '../../components/sections/InventoryContent';
import Footer from '../../components/layout/Footer';

export default function InventarioPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="inventario" />

      <main className="pt-16">
        <InventoryContent />
      </main>

      <Footer />
    </div>
  );
}